'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var versionHelper = require('../../helper/versionHelper');
var styleHelper = require('../../helper/styleHelper.js');

var CheckIcon = React.createClass({
  propTypes : {
    isChecked : React.PropTypes.oneOfType([React.PropTypes.bool,React.PropTypes.string]),
    size : React.PropTypes.number,
    color : React.PropTypes.string,
    left : React.PropTypes.number,
    top : React.PropTypes.number,
    enabled:React.PropTypes.oneOfType([React.PropTypes.bool,React.PropTypes.string])
  },

  render : function(){
    var enabled = true;
    if(this.props.enabled !== undefined){
      enabled = this.props.enabled === true || this.props.enabled === 'true';
    }
    var style={
      width : this.props.size || this.getDefaultSize(),
      height : this.props.size || this.getDefaultSize(),
      left : this.props.left || 0,
      top : this.props.top || 0,
      position :this.props.position || 'absolute',
      cursor: 'pointer',
      pointerEvents : enabled?'auto':'none'
    };
    return (<canvas style={style} width={this.props.size|| this.getDefaultSize()} height={this.props.size||this.getDefaultSize()} onClick={this.props.onClick}/>);
  },

  getDefaultSize: function () {
    return versionHelper.isMobileApp() ? 15 : 13;
  },

  componentDidMount : function(){
    this.repaint();
  },

  componentDidUpdate : function(){
    this.repaint();
  },

  componentWillUnmount : function(){
    if(this.requestID){
      cancelAnimationFrame(this.requestID);
    }
  },

  repaint : function(){
    var canvas = ReactDOM.findDOMNode(this);
    var graphics = canvas.getContext('2d');
    var self = this;
    var left;
    var top;
    var size = this.props.size || this.getDefaultSize();
    var isChecked = this.props.isChecked === 'true' || this.props.isChecked === true;
    this.requestID = window.requestAnimationFrame(function(){
      graphics.clearRect(0,0,size,size);
      graphics.fillStyle = '#ffffff';
      //graphics.strokeStyle = self.props.color || '#000';
      graphics.strokeStyle = styleHelper.getBorderColor(self.props) || '#000';

      graphics.lineWidth = 1;
      graphics.beginPath();
      graphics.rect(0,0,size,size);
      graphics.closePath();
      graphics.fill();
      graphics.stroke();
      if(isChecked){
        if(size > 20){
          graphics.lineWidth = 2;
        }
        left = size * 0.1;
        top = size * 0.55;
        graphics.moveTo(left,top);
        left = size * 0.4;
        top = size * 0.8;
        graphics.lineTo(left,top);
        left = size * 0.9;
        top = size * 0.2;
        graphics.lineTo(left,top);
        graphics.stroke();
      }

    });
  }
});

module.exports = CheckIcon;


// WEBPACK FOOTER //
// ./src/views/common/CheckIcon.jsx